import { render, staticRenderFns } from "./DFRLineItem.vue?vue&type=template&id=151f434f"
import script from "./DFRLineItem.vue?vue&type=script&lang=js"
export * from "./DFRLineItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports